export enum UserMutationTypes{
    LOGIN_USER='LOGIN_USER',
    SET_UPDATE_ACTIVE_CUSTOMER='SET_UPDATE_ACTIVE_CUSTOMER',
    SET_ACTIVE_CUSTOMER='SET_ACTIVE_CUSTOMER',
    LOGOUT_USER='LOGOUT_USER',
    RE_FECTH_ACTIVE_CUSTOMER='RE_FECTH_ACTIVE_CUSTOMER'
}